import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { ListAllVoucherUsersQuery, listAllVoucherUsers } from '~/services/PromoService';

export const allVoucherUsersQueryKeys = {
  all: ['all-voucher-users'] as const,
  lists: () => [...allVoucherUsersQueryKeys.all, 'list'] as const,
  list: (query: ListAllVoucherUsersQuery) => [...allVoucherUsersQueryKeys.lists(), query] as const,
};

type Params = {
  query: ListAllVoucherUsersQuery;
  enabled?: boolean;
};

export function useListAllVoucherUsers({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: allVoucherUsersQueryKeys.list(query),
    queryFn: async ({ signal }) => listAllVoucherUsers(query, { signal }),
    enabled,
    placeholderData: keepPreviousData,
  });
}
